import styled from "styled-components";

export const Container = styled.div`
  margin-top: 4vh;
  padding-bottom: 2%;
  display: flex;
  align-items: center;
  justify-content: center;

  .step-tr {
    font-size: 12px;
    font-family: 'Nunito';
    color: #9999ff;
    text-align: center;
    padding: 1em 0.5em;
  }

  .active {
    color: white;
  }

`;